/* 
大服务测试

CorpId
ww3e91b4978b8d1b47

AgentId 
1000027


大服务线上

CorpId
wx63db76756010ee9c

AgentId 
1000082

*/

/* 
为方便测试，测试环境分支develop上需写死这两个id
*/
export const corpId = import.meta.env.VITE_WORKCHAT_CORPID
export const agentId = import.meta.env.VITE_WORKCHAT_AGENTID
export const corpSignCode = 'default'
export const appSignCode = 'dafuwuwork'
